import proxy from "api/proxy";

import ModelSaleLine from "./ModelSaleLine";
import ModelParty from "./ModelParty";
import WizardAddPayment from "../components/WizardAddPayment";
import ProductDiscount from "../components/ProductDiscount";
import { ModalWizzardFolios } from "../components/ModalWizardFolios";
import { ModalWizzardEvents } from "../components/ModalWizardEvents";
import { generateInvoiceHTML } from "../templates/invoice";
import { getStorage } from "store/local";
import funcs from "tools/functions";
import tools from "tools/dates";
import { PlusCircleIcon } from "components/Icons";
import useMainStore from "store/mainStore";

const KIND_OPTIONS = [
  { id: "reservation", name: "reservation" },
];

const stateColors = {
  draft: "gray",
  cancelled: "rose",
  quotation: "amber",
  processing: "indigo",
  transferred: "sky",
  done: "lime",
};

const onPrintBrowser = async (record) => {
  const model = "sale.sale";
  const session = await getStorage("ctxSession");
  const imageLogo = funcs.base64ToBlobUrl(session.company_logo, "png");
  const terminal = funcs.getCookie();
  const args = { user_id: session.user, device_id: Number(terminal.device_id) };

  const { data: ctxPrinting } = await proxy.methodCall({
    model: model,
    method: "get_printing_context",
    args: [args],
  });

  const argSale = {
    type_doc: "invoice",
    sale_id: record.id,
  };

  const { data: sale } = await proxy.methodCall({
    model: model,
    method: "get_data",
    args: [argSale],
  });

  const _sale = { ...record, ...sale };
  _sale.order = sale?.order;
  _sale.payment_term = sale?.payment_term;
  if (_sale.courtesy) {
    _sale.total_discount_amount = _sale["lines."].reduce((total, item) => {
      return total + item.base_price * item.quantity;
    }, 0);
  }

  let htmlTax;
  const infoTransferRoom = "";
  const infoTransfer = "";

  const htmlContent = await generateInvoiceHTML(
    _sale,
    ctxPrinting,
    sale,
    record,
    htmlTax,
    infoTransferRoom,
    infoTransfer,
    imageLogo,
  );
  const renderDocument = await getRenderDocument(htmlContent);
  await new Promise((resolve) => setTimeout(resolve, 600));
  renderDocument.print();
};

async function getRenderDocument(htmlContent) {
  const generatePrint = window.open("", "", "width=500,height=600");
  generatePrint.document.open();
  generatePrint.document.write(htmlContent);
  generatePrint.document.close();
  return generatePrint;
}

const onChangeLines = (activeRecord) => {
  if (activeRecord.lines) {
    const totalAmount = Array.from(activeRecord.lines.values()).reduce(
      (total, item) => {
        const sale_price =
          item.unit_price_w_tax ?? item.product.sale_price_w_tax;
        return total + item.quantity * sale_price;
      },
      0,
    );
    activeRecord.total_amount = totalAmount.toFixed(0);
  }
  return activeRecord;
};

const onChangeReservation = (activeRecord) => {
  if (activeRecord?.kind !== "reservation") {
    return activeRecord;
  }
};

const visiblePrint = (_, record) => {
  let res = false;
  if (
    (record.state === "draft" &&
      record.invoice_type === "M" &&
      record.number) ||
    record.state === "processing" ||
    record.state === "transferred" ||
    record.state === "done" ||
    record.kind === "reservation"
  ) {
    res = true;
  }
  return res;
};

const visibleFolio = (_, record, config) => {
  let res = false;
  if (
    record.state === "quotation" &&
    record.lines &&
    record.lines.size > 0 &&
    config?.modules_active?.includes("hotel")
  ) {
    res = true;
  }
  return res;
};

const visibleTransfer = (_, record) => {
  return record.state === "quotation" && record.lines && record.lines.size > 0;
};

const disabledField = (record) => {
  return record.state !== "draft";
};

const disabledReservation = (record) => {
  let res = true;
  const session = getStorage("ctxSession");
  const sellerPermits = session.groups.some(
    (group) => group.name === "Venta en Reserva",
  );
  if (record.state !== "draft" || sellerPermits) {
    res = false;
  }
  return res;
};

const visibleDiscount = (_, record, config) => {
  return record.state !== "draft" || !config.global_discount ? false : true;
};
// Revisar funcion
const visibleResidual = (name, record, config) => {
  // return record.state == "draft" ? false : true;
  return true;
};

const visiblePay = (_, record) => {
  console.log("recordvisiblePay", record);
  let res = false;
  if (
    record?.kind === "reservation" ||
    (record.lines &&
      record.lines.size > 0 &&
      record.party &&
      record.residual_amount !== 0 &&
      record.state !== "transferred" &&
      record.state !== "draft")
  ) {
    res = true;
  }
  return res;
};

const visibleCourtesy = (_, record, config) => {
  let res = false;
  if (
    record.lines &&
    record.lines.size > 0 &&
    record.party &&
    record.residual_amount !== 0 &&
    record.state === "quotation" &&
    !["transferred", "done"].includes(record.state) &&
    config?.allow_courtesy
  ) {
    res = true;
  }
  return res;
};

const visibleQuote = (_, record) => {
  let res = false;
  if (record.state === "draft" && record.lines && record.lines.size > 0) {
    res = true;
  }

  return res;
};

const visibleShipmentDate = (_, record) => {
  let res = false;
  if (record?.kind === "reservation") {
    res = true;
  }

  return res;
};

const onChangeParty = async (record, storeRec) => {
  if (record.party) {
    const { data } = await proxy.search(
      "party.party",
      [["id", "=", record.party.id]],
      ["addresses"],
    );
    if (data && data[0]?.addresses?.length > 0) {
      storeRec.shipment_address = data[0].addresses[0];
      storeRec.invoice_address = data[0].addresses[0];
    } else {
      storeRec.shipment_address = null;
      storeRec.invoice_address = null;
    }
  }
};

const getFilters = () => {
  const { record } = useMainStore();
  return {
    draft: [["state", "=", "draft"]],
    done: [["state", "=", "done"]],
    transferred: [["state", "=", "transferred"]],
    reservation: [
      ["kind", "=", "reservation"],
      ["shipment_date", "=", record?.shipment_date],
    ],
  };
};

async function functionSendEmail(record) {
  if (record.id < 0) return;
  const { data } = proxy.methodInstance({
    model: "sale.sale",
    method: "send_email",
    instance: record.id,
  });
  return data;
}

const visibleSendEmailButton = (_, record) => {
  let res = false;
  if (record?.kind === "reservation" && record.id > 0) {
    res = true;
  }

  return res;
};
const today = tools.dateToday();

const getView = (config) => {
  const session = getStorage("ctxSession");
  const DictCtxView = {
    model: "sale.sale",
    activeSearch: true,
    filters: getFilters,
    domain: [
      ["shop", "=", parseInt(session.shop, 10)],
      ["sale_date", "=", `${today}`],
    ],
    reports: [
      {
        name: "sale.sale",
        description: "Factura de venta",
        send_print: true,
        visible: (record) => record?.id > 0,
        // send_email: "send_email",
      },
    ],
    form_action: ["save", "edit", "add"],
    table_action: ["edit"],
    pagination: [],
    limit: 20,
    tags: {
      state: stateColors,
    },
    selectable: null, // Options for table rows: null, multi, one
    title: { field: "numeric", model: true },
    webfields: {
      id: { type: "integer", readOnly: true },
      name: { type: "name", readOnly: true },
      number: { type: "char", readOnly: true, searchable: true },
      "party.id_number": {
        type: "char",
        searchable: true,
      },
      "party.mobile": {
        type: "char",
        call: ["mobile", "whatsapp"],
      },
      party: {
        type: "many2one",
        model: "party.party",
        ctxView: ModelParty.ctxView(),
        required: true,
        searchable: true,
        withChange: onChangeParty,
        attrs: [
          "account_receivable",
          "addresses",
          "addresses.name",
          "mobile",
          "id_number",
        ],
        readOnly: disabledField,
      },
      create_uid: {
        type: "many2one",
        model: "res.user",
        readOnly: true,
      },
      courtesy: {
        type: "boolean",
        readOnly: true,
      },
      payment_term: {
        type: "many2one",
        required: true,
        model: "account.invoice.payment_term",
        translate: true,
        readOnly: true,
      },
      invoice_address: {
        type: "many2one",
        model: "party.address",
        recSearch: () => [],
      },

      sale_date: {
        type: "date",
        readOnly: true,
        searchable: true,
        default: () => new Date(),
        required: true,
      },

      shipment_date: {
        type: "date",
        readOnly: true,

        visible: visibleShipmentDate,
      },

      source: {
        type: "many2one",
        model: "sale.source",
        readOnly: true,
      },

      invoice_method: {
        type: "char",
        required: false,
      },
      state: {
        type: "char",
        readOnly: true,
        translate: true,
        default: "draft",
        tags: stateColors,
      },
      invoice_number: {
        type: "char",
        readOnly: true,
        searchable: true,
      },

      residual_amount: {
        type: "numeric",
        readOnly: true,
        rounded: true,
        visible: visibleResidual,
      },
      paid_amount: {
        type: "numeric",
        readOnly: true,
        rounded: true,
        visible: visibleResidual,
      },
      shop: {
        type: "many2one",
        model: "sale.shop",
        readOnly: true,
        required: true,
      },
      kind: {
        type: "selection",
        options: KIND_OPTIONS,
        translate: true,
        withChange: onChangeReservation,
        readOnly: disabledReservation,
      },
      total_amount: {
        type: "numeric",
        readOnly: true,
        rounded: true,
      },
      comment: {
        type: "char",
        searchable: true,
        readOnly: disabledField,
      },
      description: {
        type: "char",
        searchable: true,
        readOnly: disabledField,
      },
      sale_device: {
        type: "many2one",
        model: "sale.device",
        recSearch: () => [],
        required: true,
        readOnly: true,
      },

      price_list: {
        type: "many2one",
        recSearch: () => [],
        model: "product.price_list",
        required: false,
        readOnly: true,
      },

      lines: {
        type: "one2many",
        model: "sale.line",
        ctxView: ModelSaleLine.ctxView(config),
        withChange: onChangeLines,
      },
      agent: {
        type: "many2one",
        model: "commission.agent",
        searchable: true,
        readOnly: true,
      },
      pay: {
        type: "button",
        button_method: "",
        visible: ProductDiscount,
        color: "blue",
        onSuccessMsg: "ORDEN COMANDADA...!",
      },
      add_payment: {
        type: "button_wizard",
        Component: WizardAddPayment,
        color: "lime",
        visible: visiblePay,
        resetWizard: false,
      },
      folios: {
        type: "button_wizard",
        Component: ModalWizzardFolios,
        color: "blue",
        visible: (name, record) => visibleFolio(name, record, config),
        resetWizard: false,
      },
      transferred_events: {
        type: "button_wizard",
        Component: ModalWizzardEvents,
        color: "yellow",
        visible: visibleTransfer,
        resetWizard: false,
      },
      add_discount: {
        type: "button_wizard",
        Component: ProductDiscount,
        color: "blue",
        icon: <PlusCircleIcon className="h-5 w-5 fill-current" />,
        visible: (name, record) => visibleDiscount(name, record, config),
        resetWizard: false,
      },
      pay_method: {
        type: "button",
        method: "create_sale",
        visible: visiblePay,
        style: "p-22 w-full",
      },
      add_courtesy: {
        type: "button",
        method: "set_courtesy",
        visible: (name, record) => visibleCourtesy(name, record, config),
        style: "p-22 w-full",
      },
      send_email: {
        type: "button",
        method: functionSendEmail,
        visible: visibleSendEmailButton,
        style: "p-22 !w-full",
        color: "black",
      },
      quote: {
        type: "button",
        button_method: "quote",
        visible: visibleQuote,
        style: "p-22 !w-full",
      },
      cancel: {
        type: "button",
        button_method: "cancel",
        visible: true,
        style: "p-22 w-full",
        color: "rose",
      },

      printBrowser: {
        type: "button",
        method: onPrintBrowser,
        visible: visiblePrint,
        color: "amber",
        loading: false,
      },
    },
    webtree: [
      { name: "number", width: "20%" },
      { name: "invoice_number", width: "20%" },
      { name: "party" },
      { name: "description" },
      { name: "party.id_number" },
      { name: "party.mobile", widget: "call_action" },
      { name: "create_uid" },
      { name: "sale_date" },
      { name: "shipment_date" },
      { name: "kind" },
      { name: "courtesy" },
      { name: "paid_amount" },
      { name: "state", widget: "badge" },
    ],
    webform: [
      { name: "party", widget: "search_add_new", edit: false },
      {
        id: "customer",
        grid: [{ name: "sale_date" }, { name: "number" }],
        size: [1, 2],
        span: "col-span-1",
      },
      {
        id: "consumer_party",
        grid: [{ name: "sale_device" }, { name: "agent" }, { name: "shop" }],
        size: [1, 3],
        span: "col-span-2",
      },
      {
        id: "btns_discount",
        grid: [{ name: "description" }, { name: "add_discount" }],
        size: [1, 2],
        span: "col-span-2",
      },

      { name: "lines", component: "modal" },
      {
        id: "discounts",
        grid: [
          { name: "state", width: "7%" },
          { name: "kind" },
          { name: "shipment_date" },
          { name: "courtesy" },
        ],
        size: [1, 4],
        span: "col-span-1",
      },

      {
        id: "paid",
        grid: [
          { name: "total_amount" },
          { name: "paid_amount" },
          { name: "residual_amount" },
        ],
        size: [1, 3],
        span: "col-span-1",
      },
      {
        id: "actions",
        grid: [
          { name: "quote" },
          { name: "send_email" },
          { name: "add_payment" },
          { name: "folios" },
          { name: "transferred_events" },
          { name: "add_courtesy" },
          { name: "printBrowser" },
        ],
        size: [1, 4],
        span: "col-span-2",
      },
    ],
  };

  return DictCtxView;
};

export default { ctxView: getView };
